import { useEffect, useState } from "react";
import { fetchOneTable } from "../../api/application/table";
import type { APITable } from "../../api/infrastructure/table.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";
import { showToast } from "../shared/global-tools/toast-system";

export default function useGetTable({
  referenceId,
  tableId,
  preloadData = true,
}: {
  referenceId?: number;
  tableId?: number;
  preloadData?: boolean;
} = {}) {
  const [table, setTable] = useState<APITable>();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchTable = async (refId: number, tblId: number) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      try {
        const result = await fetchOneTable(refId, tblId);
        setTable(result);
      } catch (error) {
        console.error("Error fetching table:", error);
        showToast("Error fetching table", { severity: "error" });
      } finally {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (!preloadData) return;
    if (referenceId === undefined || tableId === undefined) return;
    fetchTable(referenceId, tableId);
  }, [referenceId, tableId, preloadData]);

  return {
    table,
    loadingTable: loading,
    fetchTable,
    setTable,
  };
}
